var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"entry-cursor absolute pointer-events-none",style:({
    visibility: _vm.dragging ? null : 'hidden',
    top: _vm.posY - _vm.deltaY + 'px',
    left: _vm.posX - _vm.deltaX + 'px'
  }),attrs:{"draggable":"false"}},[_vm._t("default",null,{"entry":_vm.entry})],2)}
var staticRenderFns = []

export { render, staticRenderFns }